export const LIST_ALL_CUSTOMERS = 'LIST_ALL_CUSTOMERS';
export const STORE_ALL_CUSTOMERS = 'STORE_ALL_CUSTOMERS';
export const SAVE_CUSTOMER = 'SAVE_CUSTOMER';
export const STORE_UPDATED_CUSTOMER = 'STORE_UPDATED_CUSTOMER';
export const GET_CUSTOMER_POINT_HISTORY = 'GET_CUSTOMER_POINT_HISTORY';
export const STORE_CUSTOMER_POINT_HISTORY = 'STORE_CUSTOMER_POINT_HISTORY';

export const LIST_ALL_HISTORICAL_CUSTOMERS = 'LIST_ALL_HISTORICAL_CUSTOMERS';
export const STORE_ALL_HISTORICAL_CUSTOMERS = 'STORE_ALL_HISTORICAL_CUSTOMERS';
export const RESTORE_HISTORICAL_CUSTOMER = 'RESTORE_HISTORICAL_CUSTOMER';

export const STORE_UPDATED_CUSTOMER_IMAGE_WITH_PREVIEW =
  'STORE_UPDATED_CUSTOMER_IMAGE_WITH_PREVIEW';

export const STORE_UPDATED_CUSTOMER_WITH_PREVIEW =
  'STORE_UPDATED_CUSTOMER_WITH_PREVIEW';
export const PREVIEW_CUSTOMER_FILE = 'PREVIEW_CUSTOMER_FILE';
export const DELETE_CUSTOMER_ACCOUNT = 'DELETE_CUSTOMER_ACCOUNT';

export const LIST_CUSTOMERS_PENDING = 'LIST_CUSTOMERS_PENDING';

export const DELETE_CUSTOMER_PENDING = 'DELETE_CUSTOMER_PENDING';

export const SET_CUSTOMER_TICKET = 'SET_CUSTOMER_TICKET';

export const ENROLL_CUSTOMER = 'ENROLL_CUSTOMER';
export const PREVIEW_CUSTOMER_IMAGE = 'PREVIEW_CUSTOMER_IMAGE';
export const LIST_CUSTOMERS_POINTS = 'LIST_CUSTOMERS_POINTS';

export const STORE_CUSTOMERS_POINTS = 'STORE_CUSTOMERS_POINTS';

export const STORE_CUSTOMERS_PENDING = 'STORE_CUSTOMERS_PENDING';

export const STORE_CUSTOMER_TICKET = 'STORE_CUSTOMER_TICKET';

export const LIST_RAFFLE_CUSTOMERS = 'LIST_RAFFLE_CUSTOMERS';
export const STORE_ALL_RAFFLE_CUSTOMERS = 'STORE_ALL_RAFFLE_CUSTOMERS';

export const CLEAR_ALL_CUSTOMERS = 'CLEAR_ALL_CUSTOMERS';

export const PREVIEW_POINT_WATCHING_IMAGE = 'PREVIEW_POINT_WATCHING_IMAGE';

export const STORE_UPDATED_POINT_WATCHING_IMAGE_WITH_PREVIEW =
  'STORE_UPDATED_POINT_WATCHING_IMAGE_WITH_PREVIEW';

export const VALIDATE_CUSTOMER_NAME = 'VALIDATE_CUSTOMER_NAME';
